import React, { useState } from "react";
import { fetchUsers, deleteUser } from "./SkeyeingestUsersAPI";
import SkeyeingestUsersTable from "./SkeyeingestUsersTable";
import SkeyeingestAddUserDialog from "./SkeyeingestAddUserDialog";
import SkeyeingestEditUserDialog from "./SkeyeingestEditUserDialog";
import PageLayout from "../../../components/PageLayout";
import SearchToolbar from "../../../components/SearchToolbar";
import usePageTitle from "../../../services/usePageTitle";
import usePageState from "../../../hooks/usePageState";
import useIsRoleUser from "../../../hooks/useIsRoleUser";
import skeyeingestUsersHelp from "../../../content/help/skeyeingest-users.json";

export default function SkeyeingestUsers({ pageTitle = "Skeyeingest Users" }) {
  usePageTitle("SkeyeIngest Users - SkeyeGate™");

  const {
    filteredData,
    loading,
    searchText,
    page,
    pageSize,
    messageApi,
    contextHolder,
    handleSearch,
    clearFilter,
    loadData,
    onPageChange,
  } = usePageState({
    fetchFn: fetchUsers,
    filterFields: [
      "name",
      "email",
      (u) => u.roles?.join(" "),
      (u) => u.groups?.join(" "),
    ],
  });

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);

  const isRoleUser = useIsRoleUser();

  const handleEditClick = (user) => {
    setUserToEdit(user);
    setEditModalOpen(true);
  };

  const handleDeleteUser = async (username) => {
    try {
      await deleteUser(username);
      messageApi.success("User deleted successfully.");
      loadData();
    } catch (error) {
      messageApi.error("Failed to delete user");
    }
  };

  return (
    <PageLayout
      title={pageTitle}
      logo="/img/majesteye-icon-skeye-ingest-square-white-background-no-label"
      description="Manager for Skeyeingest users, allowing you to create, edit, and organize your user accounts and permissions in one place."
      helpContent={skeyeingestUsersHelp}
    >
      {contextHolder}
      <SearchToolbar
        search={searchText}
        onSearchChange={handleSearch}
        onClearFilter={clearFilter}
        addButtonLabel="Add User"
        onAdd={() => setAddModalOpen(true)}
        showAdd={!isRoleUser}
      />
      <SkeyeingestUsersTable
        data={filteredData}
        loading={loading}
        page={page}
        pageSize={pageSize}
        onPageChange={onPageChange}
        onEditUser={handleEditClick}
        onDeleteUser={handleDeleteUser}
        isRoleUser={isRoleUser}
      />
      <SkeyeingestAddUserDialog
        open={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        onSuccess={loadData}
        messageApi={messageApi}
      />
      <SkeyeingestEditUserDialog
        open={editModalOpen}
        user={userToEdit}
        onClose={() => setEditModalOpen(false)}
        onSuccess={loadData}
        messageApi={messageApi}
      />
    </PageLayout>
  );
}
